
<div class="container" style="border:1px solid #bebaba">
  <br />
  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">Notice/FAQs</h3>
      <p>Please use the links below to view a full copy of the various Notices.</p>
      <b>Notice of Settlements with Agri Stats, House of Raeford, Prestage, Foster Farms, Perdue, JOTS or Butterball Settlements</b>
      <ul>
        <li>
          <a href="../../../assets/docs/AgriStats/Exhibit 1 - Revised 9-4-26 Long Form Notice - Final 09042026.pdf"
             target="_blank">
            Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/Exhibit 2 - Revised 9-2-26 Short Form Notice - Final 090426.pdf"
             target="_blank">
            Short Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/aviso_acuerdos_pavo_espanol-2.pdf"
             target="_blank">
            La Nota
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/AgriStats/aviso_corto_acuerdos_pavo_espanol.pdf"
             target="_blank">
            Aviso
          </a>
        </li>
      </ul>
      <b>Class Certification, Cooper Farms & Farbest Foods Settlements</b>
      <ul>
        <li>
          <a href="../../../assets/docs/Certified/Turkey - CooperFarbest-Long Form Notice- Final.pdf"
             target="_blank">
            Long Form Notice/FAQs
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Certified/Turkey - CooperFarbest-Short Form Notice- Final.pdf"
             target="_blank">
            Short Form Notice
          </a>
        </li>
      </ul>
      <b>Cargill Settlement</b>
      <ul>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/Turkey - Cargill-Long Form Notice.pdf"
             target="_blank">
            Long Form Notice/FAQs
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/CourtDocsCargill/Turkey- Cargill- Short Form Notice.pdf"
             target="_blank">
            Publication Notice
          </a>
        </li>

        <li>
          <a href="../../../assets/docs/CourtDocsCargill/Turkey- Cargill- Email Notice.pdf"
             target="_blank">
            Email Notice
          </a>
        </li>
      </ul>
      <b>Tyson Settlement </b>
      <ul>
        <li>
          <a href="../../../assets/docs/Notice/Tyson Turkey Long Form Notice Draft 8-30-21 v2.pdf"
             target="_blank">
            Long Form Notice/FAQs
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Notice/Tyson Publication Notice Draft 8-30-21 v2.pdf"
             target="_blank">
            Publication Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Notice/Test Email.pdf"
             target="_blank">
            Email Notice
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
